import type { InfractionCreateSchema } from "../schemas/infraction-create.schema";
import type { InfractionDetailApiResponse } from "../types/infraction-api.types";

function parseIsoToFormDate(iso: string | null | undefined): string {
	if (!iso) {
		return "";
	}

	return iso.split("T")[0] ?? "";
}

function parseOccurredAt(iso: string): { date: string; time: string } {
	const [datePart, timePart] = iso.split("T");
	const time = timePart ? timePart.slice(0, 5) : "";

	return {
		date: datePart ?? "",
		time,
	};
}

export function mapInfractionDetailToFormValues(
	detail: InfractionDetailApiResponse
): InfractionCreateSchema {
	const { date, time } = parseOccurredAt(detail.occurredAt);

	return {
		vehicleId: detail.vehicleId,
		ait: detail.ait ?? "",
		issuingAuthorityId: detail.issuingAuthorityId,
		issuingAuthorityCode: detail.issuingAuthorityCode ?? "",
		isAnttInfraction: detail.issuingAuthorityIsAntt ?? detail.isAntt,
		occurredDate: date,
		occurredTime: time,
		location: detail.location ?? "",
		infractionCode: detail.infractionCode ?? "",
		breakdown: detail.breakdown ?? "",
		description: detail.description ?? "",
		severity: detail.severity ?? null,
		points: detail.points,
		offenderType: detail.offenderType ?? 0,
		originalAmount: detail.originalAmount,
		driverIndicationDeadline: parseIsoToFormDate(
			detail.driverIndicationDeadline
		),
		dueDate: parseIsoToFormDate(detail.dueDate),
		paymentDate: parseIsoToFormDate(detail.paymentDate),
		driverId: detail.driverId,
		transferPointsToDriver: detail.transferPointsToDriver,
		infractionNoticeFile: null,
		penaltyNotificationFile: null,
		receiptsFile: null,
	};
}
